import { InsightsTimeframes, navigableInsightsTimeframes } from '@griply/types';
import React from 'react';
import { InsightsTimeframeSelection } from 'shared/components/ui/insights-timeframe-selection';
import { TimeframeNavigationButtons } from 'shared/components/ui/timeframe-navigation-buttons';

import * as Styled from './meta-statistics-timeframe.style';

export type MetaStatisticsTimeframeProps = {
  timeframe: InsightsTimeframes;
  onChange: (timeframe: InsightsTimeframes) => void;
  onPrev: () => void;
  onToday: () => void;
  onNext: () => void;
  isNextDisabled: boolean;
};

export const MetaStatisticsTimeframe: React.FC<
  MetaStatisticsTimeframeProps
> = ({ timeframe, onChange, onPrev, onToday, onNext, isNextDisabled }) => (
  <Styled.Container>
    <InsightsTimeframeSelection
      value={timeframe}
      onChange={onChange}
      timeframes={navigableInsightsTimeframes}
      hasDarkBackground
      isFullWidth
    />
    <TimeframeNavigationButtons
      onPrev={onPrev}
      onToday={onToday}
      onNext={onNext}
      isNextDisabled={isNextDisabled}
      hasDarkBackground
    />
  </Styled.Container>
);
